import { getFunctions, httpsCallable } from 'firebase/functions';
import { SubscriptionPlan, OneTimePurchase } from '@/types/stripe';

// getFunctions() sin argumentos usará la instancia de Firebase inicializada por defecto.
const functions = getFunctions();

// Define la función para obtener la configuración de productos
export const getProductsConfig = httpsCallable<
  void, 
  { subscriptionPlans: SubscriptionPlan[]; oneTimePurchases: OneTimePurchase[]; }
>(
  functions,
  'getProductsConfig'
);

// Define la función para crear una sesión de checkout
export const createCheckoutSession = httpsCallable<
  { productKey: string; isSubscription: boolean; cycle?: 'monthly' | 'yearly'; successUrl: string; cancelUrl: string; }, 
  { sessionId: string; }
>(
  functions,
  'createCheckoutSession'
);

// Define la función para crear un enlace al portal del cliente de Stripe
export const createPortalLink = httpsCallable<
  { returnUrl: string; }, 
  { url: string; }
>(
  functions,
  'createPortalLink'
);

// Define la función para listar las facturas de Stripe
export interface InvoiceInfo {
  id: string;
  createdAt: number;
  amount: number;
  status: string;
  pdfUrl: string | null;
  lines: {
    id: string;
    description: string | null;
    amount: number;
  }[];
}

export const listInvoices = httpsCallable<{ starting_after?: string }, { invoices: InvoiceInfo[], hasMore: boolean }>(
  functions,
  'listInvoices'
);

// Define la función para validar una sesión de checkout
export const validateCheckoutSession = httpsCallable<
  { sessionId: string; },
  { status: string; payment_status: string; }
>(
  functions,
  'validateCheckoutSession'
);

// Define la función para listar las suscripciones
export const listSubscriptions = httpsCallable<
  void,
  any[] // Reemplazar 'any' con una interfaz más específica si es necesario
>(
  functions,
  'listSubscriptions'
);